/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState } from 'react';
import { FieldArray } from 'formik';
import { GridColumnTitle, Label } from 'components/Form';

import {
  TableHeader,
  TableColumn,
  InlineLabel,
  TableHead,
  TableRow,
  TableBody,
  Table,
  CustomField
} from './styles';
import Icon from "components/Icon";


const ResponsiveTable = ({ columns = [], data = [], changeRemoveAttachments, changeShowAttachments}) => {

  const removeAttachment = value => {
    let elementToRemove, newAttachments;

    elementToRemove = data.find((att, index) => att.id === value.id);
    newAttachments = data.filter(attachment => attachment.id !== elementToRemove.id);
    
    changeRemoveAttachments(newAttachments);    
  }

  return (
    <div style={{ marginLeft: 15, marginRight: 15 }}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column, index) =>
              <TableHeader key={index} minWidth={column.minWidth} maxWidth={column.maxWidth}>
                <GridColumnTitle>
                  {!changeShowAttachments && column.title === 'Remove' ? '' : column.title}
                </GridColumnTitle>
              </TableHeader>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <FieldArray
            name="tableData"
            render={() =>
              data.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column, index) =>
                    <TableColumn key={index}>
                      <InlineLabel>
                        {column.title}
                      </InlineLabel>
                      {column.component && <CustomField>
                        {column.component(row)}
                      </CustomField>}
                      {!column.component && <Label wordWrap fontSize={12}>
                        {row[column.key]}
                      </Label>}
                      {changeShowAttachments && (
                        changeRemoveAttachments && column.key === 'remove' && <Label wordWrap fontSize={12}>
                          <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeAttachment(row)}/>
                        </Label>)}
                    </TableColumn>
                  )}
                </TableRow>
              ))
            }
          />
        </TableBody>
      </Table>
    </div>
  );
};


export default ResponsiveTable;
